import axios from 'axios';
import {VUE_APP_APIPATH} from '@/util/globals';


export async function getCommodities(params) {
  const filter = {"is_additional.equal": false};
  return await axios.get(`${VUE_APP_APIPATH}data/commodities`, {
    params: {filter: JSON.stringify(filter),}
  });
}

//加購商品
export async function getAdditions(params) {
  const filter = {"is_additional.equal": true};
  return await axios.get(`${VUE_APP_APIPATH}data/commodities`, {
    params: {filter: JSON.stringify(filter)}
  });
}
